import { Cart } from "@commercetools/platform-sdk"
import { TFunction } from "i18next"
import { ErrorType } from "../../../error/ErrorType"
import { CartValidationBase, cartSuccess } from "../../validation/FormValidator"
import {
  CartValidationResult,
  cartError
} from "../../validation/ValidationError"

export class EmptyCartValidation extends CartValidationBase {
  private readonly t: TFunction

  constructor(t: TFunction) {
    super("EmptyCartValidation")
    this.t = t
  }
  validate: (cart: Cart) => CartValidationResult = c => {
    if (c && c.lineItems.length > 0) {
      return cartSuccess(c)
    } else {
      return cartError(ErrorType.CartValidationError, {
        message: this.t("checkout:yourBagIsEmpty")
      })
    }
  }
}
